// extracted by mini-css-extract-plugin
export default {"board":"market-select-modal_board__r8LPW","option":"market-select-modal_option__f3uXn"};